module.exports = __webpack_public_path__ + "static/media/compound-logo.fe42b94a.svg";